/**
 * PATH: apps/qa/src/lib/offline-db.ts
 * PURPOSE: IndexedDB wrapper for offline data storage and sync queue (re-export orchestrator)
 *
 * Split into:
 *   - offline-db/types.ts: DB schema types + initialization
 *   - offline-db/operations.ts: All CRUD operations
 */

// Re-export DB access
export { getDB } from './offline-db/types'

// Re-export all types
export type {
  SyncOperation,
  CachedInspection,
  CachedArea,
  CachedEvidence,
  SyncMetadata,
  QAOfflineDB,
} from './offline-db/types'

// Re-export all operations
export {
  // Inspections
  cacheInspection,
  getCachedInspection,
  getAllCachedInspections,
  deleteCachedInspection,
  // Areas
  cacheArea,
  getCachedArea,
  getAreasForInspection,
  deleteCachedArea,
  // Evidence
  storeEvidence,
  getCachedEvidence,
  getEvidenceForArea,
  getPendingEvidence,
  updateEvidenceStatus,
  deleteEvidence,
  // Sync Queue
  queueOperation,
  getPendingOperations,
  getFailedOperations,
  updateOperationStatus,
  deleteOperation,
  clearSyncedOperations,
  // Metadata
  setMetadata,
  getMetadata,
  getLastSyncTime,
  setLastSyncTime,
  // Utils
  clearAllData,
  getStorageStats,
} from './offline-db/operations'

// Default export for backward compatibility
import { getDB } from './offline-db/types'
import {
  cacheInspection, getCachedInspection, getAllCachedInspections, deleteCachedInspection,
  cacheArea, getCachedArea, getAreasForInspection, deleteCachedArea,
  storeEvidence, getCachedEvidence, getEvidenceForArea, getPendingEvidence,
  updateEvidenceStatus, deleteEvidence,
  queueOperation, getPendingOperations, getFailedOperations, updateOperationStatus,
  deleteOperation, clearSyncedOperations,
  setMetadata, getMetadata, getLastSyncTime, setLastSyncTime,
  clearAllData, getStorageStats,
} from './offline-db/operations'

export default {
  getDB,
  cacheInspection, getCachedInspection, getAllCachedInspections, deleteCachedInspection,
  cacheArea, getCachedArea, getAreasForInspection, deleteCachedArea,
  storeEvidence, getCachedEvidence, getEvidenceForArea, getPendingEvidence,
  updateEvidenceStatus, deleteEvidence,
  queueOperation, getPendingOperations, getFailedOperations, updateOperationStatus,
  deleteOperation, clearSyncedOperations,
  setMetadata, getMetadata, getLastSyncTime, setLastSyncTime,
  clearAllData, getStorageStats,
}
